<template>
  <div class="target-top__layout">
    <v-layout row wrap>
      <v-flex md6 lg6 xs12 class="target-top__layout-summary-content">
        <div class="target-top__layout__summary-subtitle">
          FEATURES
          <v-icon id="features-tooltip" class="features-more">info</v-icon>
          <div id="icons-details" style="display: none;">
            <div style="text-align:left;font-weight:600;padding:0 0 2px 3px">When the icon is coloured it has the following meaning:</div>
            <table class="icons-table">
              <tr v-for="(value, key) in features" :key="key">
                <td><img :src="value.imageValid" height="15" width="15" style="background:#ffffff;"></td>
                <td>{{value.textValid}}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="target-top__layout__summary-content-main">
          <prb-features :target="target" :features="features"></prb-features>
        </div>
      </v-flex>
      <v-flex md6 lg6 xs12 class="target-top__layout-summary-content">
        <div class="target-top__layout__summary-subtitle">CHARACTERIZATION</div>
        <div class="target-top__layout__summary-content-main">
          <prb-characterisation v-bind:score="target.score"></prb-characterisation>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import 'tippy.js/dist/tippy.css'
import tippy from 'tippy.js'
import * as F from '../../../constants/Features';

import PrbCharacterisation from './prb-characterisation/PrbCharacterisation';
import PrbFeatures from './prb-features/PrbFeatures';

export default {
  props: ['target'],
  components: {PrbCharacterisation, PrbFeatures},
  beforeMount() {
    this.features = F.FEATURES;
  },
  mounted() {
    tippy('#features-tooltip', {
      html: '#icons-details',
      duration: 1000,
      arrow: true,
      trigger: 'click'
    })
  }
}
</script>

<style scoped>
  .target-top__layout{
    width: 100%;
  }

  .target-top__layout__summary-subtitle{
    width: 100%;
    font-size: 20px;
    padding: 10px;
    font-weight: 600;
    border-left: 5px solid #455A64;
    color: #455A64;
    background: rgba(0,0,0,.03);
  }
  .target-top__layout__summary-content-main {
    max-height: 130px;
    padding: 10px 0;
  }
  .features-more {
    font-size: 18px;
    padding: 0 0 5px 0;
    cursor: pointer;
    color: #2c3e50 !important;
  }

  .features-more:hover {
    color: #1e88e5 !important;
  }

  .icons-table {
    width: 100%;
    max-width: 100%;
  }

  .icons-table td {
    padding: 0 8px !important;
    text-align: left;
  }

</style>



// WEBPACK FOOTER //
// PrbTargetTop.vue?3dcd7e14